

angular.module('dyb.util.forms', [
        'classy', 'classy-on', 'dyb.util.constants']);


var originialModule = angular.module;

angular.module = function(name, reqs, config) {
    var module  = originialModule(name, reqs, config);
    module.formDirective = formDirectiveBuilder.bind(window, module);
    return module;
};


function underscoreToCamel(s) {
   s =  (s || "").replace(/_([a-z])/g, function (g) { return g[1].toUpperCase(); });
   return s;
}


function copyFields(model, fields) {
    var data = {};
    for (var i = 0; i < fields.length; i++) {
        data[fields[i]] = angular.copy(model[fields[i]]);
    }
    return data;
}


function formDirectiveBuilder(mod, name, baseDirective) {
    return mod.directive(name, formDirective);

    // @ngInject
    function formDirective($injector, ModelConfig) {

        var base = $injector.invoke(baseDirective, this),
            rootModel = base.modelName,
            subModel = base.subModel,
            structure = ModelConfig.structure.modelNames[rootModel];

        base.formName = base.formName || subModel;

        var scopeDef = {
            rootModel: '=' + underscoreToCamel(rootModel),
            model: '=' + underscoreToCamel(subModel || rootModel),
        };

        if (!base.templateUrl) {
            if (!base.templateDirectory) {
                base.templateDirectory = rootModel + "s/";

                if(subModel) {
                    if (structure.type[subModel] === 'deep') {
                        base.templateDirectory +=
                            underscoreToCamel(structure.pluralize[subModel]);
                    } else {
                        base.templateDirectory += underscoreToCamel(subModel);
                    }
                }
            }
            base.templateUrl = base.templateDirectory + '/' + (base.templateName || name);
        }


        angular.extend(scopeDef, base.scope || {});

        base.copyData = base.copyData || function(scope) {
            return scope.model.$copyData(base.fields);
        };

        base.alterData = base.alterData || angular.identity;

        base.save = base.save || function(root, model, data) {
            return model.$saveForm(base.formName, data);
        };

        base.getSuccessMessage = base.getSuccessMessage || function(rootModel, model) {
            return (rootModel.student_name || rootModel.program_name) + " was saved successfully";
        };

        base.link = base.link || angular.noop;

        var directive = {
            restrict: 'E',
            require: '^basicForm',
            templateUrl: base.templateUrl,
            scope: scopeDef,

            link: function(scope, element, attrs, basicForm) {
                scope.data = basicForm.data = base.copyData(scope);
                scope.form = basicForm.getForm();

                if (base.setOpenData) {
                    basicForm.setOpenData = base.setOpenData.bind(base, scope);
                }

                scope[underscoreToCamel(rootModel)] = scope.rootModel;
                scope[underscoreToCamel(subModel)] = scope.model;

                angular.extend(scope, base.data);

                if (!base.fields && subModel) {
                    base.fields = ModelConfig.getDatapointNames(subModel);
                }

                if (base.fields) {
                    scope.options = ModelConfig.getOptions(base.fields);
                    scope.labels = ModelConfig.getLabel(base.fields);
                }

                if (angular.isDefined(base.init)) {
                    base.init(scope, element, attrs, basicForm);
                }

                basicForm.save = function(data) {
                    data = base.alterData(data, scope);
                    basicForm.successMessage = base.getSuccessMessage(scope.rootModel, scope.model);
                    return base.save(scope.rootModel, scope.model, data);
                };

                if (angular.isFunction(base.delete)) {
                    basicForm.setDeleteFunctions(function() {
                        return base.delete(scope.model, scope);
                    }, function() {
                        if (angular.isDefined(base.allowDelete)) {
                            return base.allowDelete(scope);
                        }
                        return true;
                    });
                }

                base.link.call(this, scope, element, attrs, basicForm);
            },
        };

        return directive;
    };
}

